import React from 'react'
import * as Popover from '@radix-ui/react-popover';
import { Transition, animated, config } from 'react-spring'
import MeetingTypeIcon from '../../../misc/MeetingTypeIcon'
import {setMeetingType} from '../../../../utils/meetings/setMeetingType'

class DocEditorMeetingInfoMeetingTypePopoverItem extends React.Component{  

	render(){	
		const {meetingType, active} = this.props
		let label
		if(meetingType === 'discovery'){
			label = 'Discovery Call'
		}else if(meetingType === 'designReview'){
			label = 'Design Review'
		}else if(meetingType === 'teamSync'){
			label = 'Team Sync'
		}else if(meetingType === 'blank'){
			label = 'None'
		}		
		const checked = active
	  return (
	  	<div onClick={()=>{this.props.handleUpdateMeetingType(meetingType)}} data-state={checked ? "checked" : "unchecked"} className={'popoverMenu-item popoverMenu-item--editMeetingType ' + (meetingType === 'blank' ? 'popoverMenu-item--editMeetingType--blank ' : '')}>
				{meetingType !== 'blank' && 
					<div className='popoverMenu-item-iconContainer'>
						<MeetingTypeIcon meetingType={meetingType} />
					</div>
				}				
				<div className='popoverMenu-item-label'>
					{label}
				</div>
			</div>
	  )
	}
}



class DocEditorMeetingInfoMeetingTypePopover extends React.Component{  

	constructor(){
		super()
		this.onRest=this.onRest.bind(this)	
		this.handleUpdateMeetingType=this.handleUpdateMeetingType.bind(this)	
		this.state={
      forceMount: false,      
    }
	}

	onRest() {  
    if(!this.props.showPopover){
      this.setState({forceMount: false})
    } else{
      this.setState({forceMount: true})
    }
  }

  handleUpdateMeetingType(meetingType){
  	const {meeting} = this.props 
  	setMeetingType(meeting.meeting_id,meetingType)
  	this.props.closePopover()
  }

	render(){	
		const {showPopover, openPopover, closePopover} = this.props
		const {forceMount} = this.state
		const translateY = -8
		const popoverSide = "bottom"
		let popoverSideOffset= 4
		let popoverAlign = "start"				
		let popoverAlignOffset= -10

	  return (
	  	<React.Fragment>
		  	<Popover.Root open={showPopover}>
					<Popover.Trigger asChild>						
						{this.props.children}
					</Popover.Trigger>					
					<Popover.Portal forceMount={showPopover ? true : forceMount}>
						<Popover.Content
							className={'editMeetingTypePopoverContainer ' + (showPopover ? ' editMeetingTypePopoverContainer--visible ' : ' editMeetingTypePopoverContainer--hidden ')} 
							onEscapeKeyDown={closePopover}
							onPointerDownOutside={closePopover}
							onInteractOutside={closePopover}						
							side={popoverSide}
							sideOffset={popoverSideOffset}
							align={popoverAlign}
							alignOffset={popoverAlignOffset}
							forceMount={showPopover ? true : forceMount}
						>
							<Transition
								items={showPopover}
								from={{ opacity: 0, transform: `translateY(${translateY}px)` }}
								enter={{ opacity: 1, transform: 'translateY(0px)'  }}
								leave={{ opacity: 0, transform: `translateY(${translateY}px)`  }}
								reverse={showPopover}
								config={{tension: 600, friction: 35}}
								onRest={this.onRest}
							>
								{(styles, item) =>
									item && 
									 <animated.div style={styles} className="editMeetingTypePopover popover"> 	
										 <div className='editMeetingTypePopover-header'>
										 	Edit Meeting Type
										 </div>
										 <DocEditorMeetingInfoMeetingTypePopoverItem 
										 	meetingType='designReview'
										 	active={this.props.activeMeetingType === 'designReview'}
										 	handleUpdateMeetingType={this.handleUpdateMeetingType}
										 />
										 <DocEditorMeetingInfoMeetingTypePopoverItem 
										 	meetingType='discovery'
										 	active={this.props.activeMeetingType === 'discovery'}
										 	handleUpdateMeetingType={this.handleUpdateMeetingType}
										 />
										 <DocEditorMeetingInfoMeetingTypePopoverItem 
										 	meetingType='teamSync'
										 	active={this.props.activeMeetingType === 'teamSync'}
										 	handleUpdateMeetingType={this.handleUpdateMeetingType}
										 />
										 <DocEditorMeetingInfoMeetingTypePopoverItem 
										 	meetingType='blank'
										 	active={this.props.activeMeetingType === 'blank'}
										 	handleUpdateMeetingType={this.handleUpdateMeetingType}
										 />
										 
									</animated.div>
								}
							</Transition>									
						</Popover.Content>
					</Popover.Portal>
				</Popover.Root>
			</React.Fragment>
	  )
	}
}

export default DocEditorMeetingInfoMeetingTypePopover
